/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_O2Inputs */

const en_mk_sol_operasional_o2 = /** @type {(inputs: Mk_Sol_Operasional_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodic reports come out in the same format every period`)
};

const id_mk_sol_operasional_o2 = /** @type {(inputs: Mk_Sol_Operasional_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan berkala keluar dengan format yang sama tiap periode`)
};

/**
* | output |
* | --- |
* | "Periodic reports come out in the same format every period" |
*
* @param {Mk_Sol_Operasional_O2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_o2 = /** @type {((inputs?: Mk_Sol_Operasional_O2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_O2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_o2(inputs)
	return en_mk_sol_operasional_o2(inputs)
});